import React, { useState, useMemo, useCallback } from 'react'
import cookies from 'js-cookie'
import { decodeGlobalId } from '~/utils/id'
import getConfig from 'next/config'

const { USER_ID_COOKIE_NAME } = getConfig().publicRuntimeConfig

export const ViewerContext = React.createContext()
export const ViewerConsumer = ViewerContext.Consumer

function ViewerProvider({ children, data = {} }) {
  const { viewer: initialViewer = null, deviceInfo = {}, currentUrl } = data
  const [viewer, setViewer] = useState(initialViewer)
  const [email, setEmail] = useState(null)
  const [createTicketAlertHandler, setCreateTicketAlertHandler] = useState(null)
  const mergeViewer = useCallback(
    partialViewer => {
      setViewer({ ...viewer, ...partialViewer })
    },
    [viewer]
  )

  const value = useMemo(() => {
    return {
      viewer,
      setViewer,
      mergeViewer,
      deviceInfo,
      currentUrl,
      email,
      setEmail,
      createTicketAlertHandler,
      setCreateTicketAlertHandler,
    }
  }, [viewer, deviceInfo, email, createTicketAlertHandler, mergeViewer, currentUrl])

  return <ViewerContext.Provider value={value}>{children}</ViewerContext.Provider>
}

export function useViewer() {
  const context = React.useContext(ViewerContext)
  if (!context) {
    throw new Error('useViewer() must be used within a ViewerProvider')
  }
  const { viewer, setViewer, mergeViewer, deviceInfo, currentUrl } = context
  return {
    viewer,
    setViewer: user => {
      setViewer(user)
      cookies.set(USER_ID_COOKIE_NAME, decodeGlobalId(user.id), { secure: true, sameSite: 'lax' })
    },
    mergeViewer,
    resetViewer: () => {
      setViewer(null)
      cookies.remove(USER_ID_COOKIE_NAME)
    },
    deviceInfo,
    currentUrl,
  }
}

export default ViewerProvider
